import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "../../appbar/AppBar";
import AppBackground from "../../components/AppBackground";
import {
  FailedCommentsSvg,
  PendingCommentsSvg,
  SpecialReviewsSvg,
  UnansweredReviewsSvg,
} from "../../components/Assets";
import OutlineBlueWithBlueTextBtn from "../../components/buttons/OutlineBlueWithBlueTextBtn";
import { REVIEW_STATUS_CODE } from "../../constants/AppConstants";
import { useFetchHome } from "../../hooks/useFetchHomePage";
import {
  FAILED_COMMENTS,
  HOME_FAIL_COMMENTS_DETAILS,
  HOME_PENDING_COMMENTS_DETAILS,
  HOME_SPECIAL_REVIEWS_DETAILS,
  HOME_UNANSWER_REVIEWS_DETAILS,
  PENDING_COMMENTS,
  SPECIAL_REVIEWS,
  UNANSWERED_REVIEWS,
} from "../../text-data";
import AiCommentServiceSetting from "../aiCommentServiceSetting/AiCommentServiceSetting";
import AppConnect from "../appConnect/AppConnect";
import RegistrationBanner from "../registrationBanner/RegistrationBanner";
import { kIN_1_WEEKS } from "../review/ReviewStatusKeys";
import RatingChart from "./RatingChart";
import TotalReviewChart from "./TotalReviewChart";
import useAuth from "../../hooks/useAuth";

const AppContent = ({ children }) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "16px 16px 0 0",
        padding: "24px 24px 36px",
      }}
    >
      {children}
    </div>
  );
};

const ReviewCardIcon = (type) => {
  switch (type) {
    case "PendingComments":
      return PendingCommentsSvg;
    case "UnansweredReviews":
      return UnansweredReviewsSvg;
    case "SpecialReviews":
      return SpecialReviewsSvg;
    case "FailedComments":
    default:
      return FailedCommentsSvg;
  }
};

const type2String = (type) => {
  switch (type) {
    case "PendingComments":
      return PENDING_COMMENTS;
    case "UnansweredReviews":
      return UNANSWERED_REVIEWS;
    case "SpecialReviews":
      return SPECIAL_REVIEWS;
    case "FailedComments":
      return FAILED_COMMENTS;
    default:
      return FAILED_COMMENTS;
  }
};

const type2Details = (type) => {
  switch (type) {
    case "PendingComments":
      return HOME_PENDING_COMMENTS_DETAILS;
    case "UnansweredReviews":
      return HOME_UNANSWER_REVIEWS_DETAILS;
    case "SpecialReviews":
      return HOME_SPECIAL_REVIEWS_DETAILS;
    case "FailedComments":
    default:
      return HOME_FAIL_COMMENTS_DETAILS;
  }
};

const ReviewCard = ({ type, number, href } = {}) => {
  const navigate = useNavigate()

  return (
    <div className="review-card flex flex-col">
      <div className="flex flex-col gap-2">
        <b className="text-lg">{type2String(type)}</b>
        <span>{type2Details(type)}</span>
      </div>
      <div
        className="flex justify-between items-center"
        style={{ height: "72px" }}
      >
        <span>
          <img src={ReviewCardIcon(type)}></img>
        </span>
        <span className="text-5xl">
          <b>{number ?? 0}</b>
          <b className="text-2xl">개</b>
        </span>
      </div>
      <OutlineBlueWithBlueTextBtn onClick={() => navigate(href)} className="w-full">자세히 보기</OutlineBlueWithBlueTextBtn>
    </div>
  );
};
export default function Home() {
  const { homeData, shopInfo, reviewChartData, starChartData, isHomeEmptyData, ceoStatus } =
    useFetchHome();
    const { ceoInfo } = useAuth();
  React.useEffect(function () {
    document.title = "SPONGE CEO";
  }, []);

  const CardOfTotalReviewChart = () => {
    return (
      <div className="review-card2">
        <p className="flex justify-between items-center">
          <b className="text-lg">최근 일주일 리뷰 수</b>
          <b className="text-2xl">{homeData?.reviewInWeek?.totalReview}개</b>
        </p>

        {homeData?.reviewInWeek?.reviewByDate && (
          <TotalReviewChart
            series={reviewChartData}
            categories={homeData?.reviewInWeek?.reviewByDate?.map((item) =>
              moment(item.date, "YYYYMMDD").format("MM.DD")
            )}
          />
        )}
      </div>
    );
  };

  const CardOfRatingChart = () => {
    return (
      <div className="review-card2">
        <p className="flex justify-between items-center">
          <b className="text-lg">최근 일주일 리뷰 평점</b>
          <b className="text-2xl">{homeData?.averageStar?.averageStar}점</b>
        </p>
        {homeData?.averageStar?.starByDates && (
          <RatingChart
            series={starChartData}
            categories={homeData?.averageStar?.starByDates?.map((item) =>
              moment(item.date, "YYYYMMDD").format("MM.DD")
            )}
          />
        )}
      </div>
    );
  };

  return (
    <AppBackground>
      <AppBar />
      <div className="mt-[60px]">
        <RegistrationBanner />
      </div>
      <AppContent>
        <h1 className="text-22 font-bold" style={{ marginBottom: "32px" }}>
          {shopInfo?.shop_name}
        </h1>
        <AppConnect />

        <AiCommentServiceSetting />

        <>
          <ReviewCard href={`/review?time=${kIN_1_WEEKS}&search_comment_reg_status_code=${REVIEW_STATUS_CODE.FAILED.code}`} type="FailedComments" number={homeData?.failedComment} />

         {ceoInfo?.ceo_type ==='PREMIUM' && <ReviewCard href={`/review/special?time=${kIN_1_WEEKS}&search_comment_reg_status_code=`} type="SpecialReviews" number={homeData?.specialReview} />}

          <ReviewCard
            href={`/review?time=${kIN_1_WEEKS}&search_comment_reg_status_code=${REVIEW_STATUS_CODE.UNANSWERED.code}`}
            type="UnansweredReviews"
            number={homeData?.unansweredReview}
          />

          <ReviewCard
            href={`/review?time=${kIN_1_WEEKS}&search_comment_reg_status_code=${REVIEW_STATUS_CODE.PENDING.code}`}
            type="PendingComments"
            number={homeData?.pendingComment}
          />

          <CardOfTotalReviewChart />
          <div className="mb-24">
            <CardOfRatingChart />
          </div>
        </>
      </AppContent>
    </AppBackground>
  );
}
